var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thx-footer"},[_c('div',{staticClass:"thx-footer-text"},[_vm._v(_vm._s(_vm.$t('thanks.footer.text', {0: _vm.money.amount / 100, 1: _vm.money.currency, 2: _vm.getInterval} )))]),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"thx-footer-image"},[_c('img',{attrs:{"src":require("@/assets/img/thanks/thank_you_small.png")}})])
}]

export { render, staticRenderFns }